"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1839],{

/***/ 51839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ myAddress_MyAddress; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
// EXTERNAL MODULE: ./api/memberAddress.js
var memberAddress = __webpack_require__(36910);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/mypage/myAddress/MyAddress-styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin: 0 0 30px 0;\n\n  .add-address-btn {\n    border: none;\n    background: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    color: #253d4e;\n    & span {\n      transition: all 0.1s;\n    }\n    :hover {\n      color: #3bb77e;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-column-gap: 5px;\n  grid-row-gap: 5px;\n  @media (max-width: 1025px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  background-color: #fff;\n  border: 1px solid #ececec;\n  border-radius: 15px;\n  overflow: hidden;\n  transition: 0.2s;\n  -moz-transition: 0.2s;\n  -webkit-transition: 0.2s;\n  -o-transition: 0.2s;\n  margin-bottom: 0.7rem;\n  margin-right: 0.7rem;\n  width: 100%;\n  cursor: pointer;\n  :hover {\n    -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n    border: 1px solid #bce3c9;\n    transition: 0.2s;\n    -moz-transition: 0.2s;\n    -webkit-transition: 0.2s;\n    -o-transition: 0.2s;\n  }\n\n  .product-badges.product-badges-position {\n    position: absolute;\n    right: 0;\n    top: 0px;\n    z-index: 9;\n    > span {\n      display: inline-block;\n      font-size: 12px;\n      line-height: 1;\n      border-radius: 0px 10px 0 20px;\n      color: #fff;\n      padding: 9px 20px 10px 20px;\n      background-color: #f74b81;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 20px 20px 30px 20px;\n\n  .address-info {\n    font-size: 14px;\n    color: #253d4e;\n\n    & li:not(:last-child) {\n      margin-bottom: 4px;\n      img {\n        margin-right: 8px;\n        max-width: 16px;\n      }\n    }\n  }\n  .basic-btns {\n    display: flex;\n    margin-right: 10px;\n    margin-bottom: 10px;\n  }\n\n  .address-btn {\n    display: flex;\n    margin-top: 1rem;\n    justify-content: space-between;\n    flex-wrap: wrap;\n\n    .select-btns {\n      display: flex;\n      margin-right: 10px;\n      margin-bottom: 10px;\n    }\n\n    & button {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      min-width: 3.2rem;\n      font-size: 14px;\n      font-weight: 400;\n      padding: 5px 20px;\n      border-radius: 5px;\n      word-break: keep-all;\n      background-color: #fff;\n      color: #253d4e;\n      border: 1px solid #253d4e;\n      :hover {\n        background-color: #253d4e;\n        color: #fff;\n      }\n    }\n\n    .btn-select {\n      border: none;\n      background-color: #3bb77e;\n      color: #fff;\n      :hover {\n        background-color: #fd7e14;\n      }\n    }\n\n    .btn-select-basic {\n      border: none;\n      background-color: #3bb77e;\n      color: #fff;\n      padding: 0 10px;\n      margin: 0;\n      :hover {\n        background-color: #f1c40f;\n      }\n    }\n\n    & button:not(:last-of-type) {\n      margin-right: 10px;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-6746e27f-0"
})(_templateObject());
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6746e27f-1"
})(_templateObject1());
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6746e27f-2"
})(_templateObject2());
var AddressBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6746e27f-3"
})(_templateObject3());
var AddressContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6746e27f-4"
})(_templateObject4());

// EXTERNAL MODULE: ./components/mypage/myAddress/new/MyAddress-new.js + 1 modules
var MyAddress_new = __webpack_require__(33685);
// EXTERNAL MODULE: ./redux/action/loading.js
var loading = __webpack_require__(19828);
;// CONCATENATED MODULE: ./components/mypage/myAddress/MyAddress.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var pageHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "12px",
    marginBottom: "22px"
};
var titleStyle = {
    margin: 0,
    fontSize: "22px",
    fontWeight: 800,
    color: "#222"
};
var subTextStyle = {
    margin: "6px 0 0",
    fontSize: "14px",
    color: "#777"
};
var addButtonStyle = {
    height: "42px",
    padding: "0 18px",
    border: "1px solid #3BB77E",
    borderRadius: "8px",
    background: "#3BB77E",
    color: "#fff",
    fontWeight: 700,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px"
};
var listWrapperStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "16px"
};
var cardStyle = function(isBasic) {
    return {
        position: "relative",
        border: isBasic ? "1px solid #3BB77E" : "1px solid #e5e7eb",
        borderRadius: "14px",
        background: "#fff",
        padding: "22px",
        boxShadow: isBasic ? "0 4px 14px rgba(59,183,126,0.12)" : "0 2px 10px rgba(0,0,0,0.035)"
    };
};
var badgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    height: "26px",
    padding: "0 10px",
    borderRadius: "13px",
    background: "#e9f7f0",
    color: "#3BB77E",
    fontSize: "12px",
    fontWeight: 800,
    marginBottom: "12px"
};
var addressNameStyle = {
    margin: 0,
    fontSize: "18px",
    fontWeight: 800,
    color: "#222"
};
var infoListStyle = {
    listStyle: "none",
    padding: 0,
    margin: "18px 0 0"
};
var infoItemStyle = {
    display: "grid",
    gridTemplateColumns: "86px 1fr",
    gap: "10px",
    fontSize: "14px",
    lineHeight: 1.6,
    marginBottom: "8px"
};
var labelStyle = {
    color: "#777",
    fontWeight: 700
};
var valueStyle = {
    color: "#333",
    wordBreak: "keep-all"
};
var buttonAreaStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "8px",
    marginTop: "22px",
    paddingTop: "16px",
    borderTop: "1px solid #f1f1f1"
};
var outlineButtonStyle = {
    height: "36px",
    padding: "0 13px",
    border: "1px solid #ddd",
    borderRadius: "7px",
    background: "#fff",
    color: "#333",
    fontSize: "13px",
    fontWeight: 700,
    cursor: "pointer"
};
var greenOutlineButtonStyle = _objectSpread({}, outlineButtonStyle, {
    border: "1px solid #3BB77E",
    color: "#3BB77E"
});
var applyButtonStyle = {
    height: "36px",
    padding: "0 15px",
    border: "1px solid #3BB77E",
    borderRadius: "7px",
    background: "#3BB77E",
    color: "#fff",
    fontSize: "13px",
    fontWeight: 700,
    cursor: "pointer"
};
var emptyBoxStyle = {
    minHeight: "260px",
    border: "1px dashed #cfd8dc",
    borderRadius: "14px",
    background: "#fafafa",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    padding: "50px 20px",
    textAlign: "center"
};
var MyAddress = function(param) {
    var _$isLoaded = param.isLoaded, loading = param.loading, ownProps = param.ownProps;
    var ref6 = (0,react.useState)(), myAddress = ref6[0], setMyAddress = ref6[1];
    var ref1 = (0,react.useState)(0), myAddressCount = ref1[0], setMyAddressCount = ref1[1];
    var ref2 = (0,react.useState)(false), isOpen = ref2[0], setIsOpen = ref2[1];
    var ref3 = (0,react.useState)(false), isEdit = ref3[0], setIsEdit = ref3[1];
    var ref4 = (0,react.useState)(), editAddress = ref4[0], setEditAddress = ref4[1];
    var fetchAddressList = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref5, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return (0,memberAddress/* fetchListMemberAddress */.F8)();
                    case 3:
                        res = _ctx.sent;
                        setMyAddressCount(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Count) || 0);
                        setMyAddress(((ref5 = res.Data) === null || ref5 === void 0 ? void 0 : ref5.Rows) || []);
                        _$isLoaded();
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchAddressList() {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteAddress = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(acode) {
            var body, res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "DeleteSet",
                            acode: acode
                        };
                        _ctx.next = 3;
                        return (0,memberAddress/* deleteMemberAddress */.ZT)(body);
                    case 3:
                        res = _ctx.sent;
                        if ((res === null || res === void 0 ? void 0 : res.code) === "0000") {
                            (0,common_alert/* successAlert */.Cq)("\uC0AD\uC81C \uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                            fetchAddressList();
                        } else {
                            ;
                            (0,common_alert/* failAlert */.qh)(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.Msg);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function deleteAddress(acode) {
            return _ref.apply(this, arguments);
        };
    }();
    var selectDefault = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(acode) {
            var body, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "DefaultSet",
                            acode: acode
                        };
                        _ctx.next = 3;
                        return (0,memberAddress/* defaultSetAddress */.$)(body);
                    case 3:
                        res = _ctx.sent;
                        if (res.code === "0000") {
                            (0,common_alert/* successAlert */.Cq)("\uC124\uC815\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                            fetchAddressList();
                        } else {
                            (0,common_alert/* failAlert */.qh)(res.data.Msg);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function selectDefault(acode) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleIsEdit = function(el) {
        setIsEdit(true);
        setIsOpen(true);
        setEditAddress(el);
    };
    var openCreateAddress = function() {
        setIsEdit(false);
        setEditAddress(undefined);
        setIsOpen(true);
    };
    var applyCheckoutAddress = function(el) {
        ownProps.setMemberAddress(el);
        ownProps.setUserInputs(_objectSpread({}, ownProps.userInputs, {
            acode: el.acode,
            base_addr: el.base_addr,
            detail_addr: el.detail_addr,
            doro_addr: el.doro_addr,
            addressGps: {
                mapx: el.mapx,
                mapy: el.mapy
            },
            addr_name: el.name,
            zipcode: el.zipcode
        }));
        ownProps.setOpenAddressModal(false);
    };
    (0,react.useEffect)(function() {
        fetchAddressList();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: loading === false && (!isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        marginBottom: "16px",
                        fontSize: "14px",
                        fontWeight: 700,
                        color: "#3BB77E"
                    },
                    children: [
                        "\uCD1D ",
                        myAddressCount,
                        "\uAC1C"
                    ]
                }),
                (myAddress === null || myAddress === void 0 ? void 0 : myAddress.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: listWrapperStyle,
                    children: myAddress.map(function(el, i) {
                        var isBasic = el.basic === "Y";
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: cardStyle(isBasic),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                        gap: "10px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    style: addressNameStyle,
                                                    children: el.name || "\uBC30\uC1A1\uC9C0"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    style: {
                                                        margin: "6px 0 0",
                                                        fontSize: "13px",
                                                        color: "#999"
                                                    },
                                                    children: el.zipcode ? "\uC6B0\uD3B8\uBC88\uD638 ".concat(el.zipcode) : ""
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                background: isBasic ? "#e9f7f0" : "#f5f5f5",
                                                color: isBasic ? "#3BB77E" : "#999",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flex: "0 0 40px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fi-rs-marker"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    style: infoListStyle,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            style: infoItemStyle,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    style: labelStyle,
                                                    children: "\uB3C4\uB85C\uBA85"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: valueStyle,
                                                    children: el.doro_addr || "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            style: infoItemStyle,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    style: labelStyle,
                                                    children: "\uC9C0\uBC88"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: valueStyle,
                                                    children: el.base_addr || "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            style: infoItemStyle,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    style: labelStyle,
                                                    children: "\uC0C1\uC138\uC8FC\uC18C"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: valueStyle,
                                                    children: el.detail_addr || "-"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: buttonAreaStyle,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                gap: "8px",
                                                flexWrap: "wrap"
                                            },
                                            children: [
                                                ownProps.isCheckout && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    style: applyButtonStyle,
                                                    onClick: function() {
                                                        return applyCheckoutAddress(el);
                                                    },
                                                    children: "\uC801\uC6A9"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    type: "button",
                                                    disabled: isBasic,
                                                    onClick: function() {
                                                        return !isBasic && selectDefault(el.acode);
                                                    },
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        gap: "6px",
                                                        height: "36px",
                                                        minWidth: "145px",
                                                        padding: "0 14px",
                                                        borderRadius: "18px",
                                                        border: "1px solid #3BB77E",
                                                        background: isBasic ? "#3BB77E" : "#fff",
                                                        color: isBasic ? "#fff" : "#3BB77E",
                                                        fontSize: "13px",
                                                        fontWeight: 700,
                                                        cursor: isBasic ? "default" : "pointer",
                                                        transition: "all .2s"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: isBasic ? "fi-rs-check" : "fi-rs-home"
                                                        }),
                                                        isBasic ? "\uAE30\uBCF8 \uBC30\uC1A1\uC9C0" : "\uAE30\uBCF8 \uBC30\uC1A1\uC9C0\uB85C \uB4F1\uB85D"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                gap: "8px",
                                                flexWrap: "wrap"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    style: outlineButtonStyle,
                                                    onClick: function() {
                                                        return handleIsEdit(el);
                                                    },
                                                    children: "\uC218\uC815"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    style: outlineButtonStyle,
                                                    onClick: function() {
                                                        return deleteAddress(el.acode);
                                                    },
                                                    children: "\uC0AD\uC81C"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, el.acode || i);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        marginTop: "24px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onClick: openCreateAddress,
                        style: emptyBoxStyle,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: "58px",
                                    height: "58px",
                                    borderRadius: "50%",
                                    background: "#e9f7f0",
                                    color: "#3BB77E",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    fontSize: "26px",
                                    marginBottom: "16px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fi-rs-plus"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                style: {
                                    margin: 0,
                                    fontSize: "18px",
                                    fontWeight: 800,
                                    color: "#333"
                                },
                                children: "\uB4F1\uB85D\uB41C \uBC30\uC1A1\uC9C0\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                style: {
                                    margin: "8px 0 0",
                                    fontSize: "14px",
                                    color: "#777"
                                },
                                children: "\uD074\uB9AD\uD558\uBA74 \uC0C8 \uBC30\uC1A1\uC9C0\uB97C \uB4F1\uB85D\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
                            })
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MyAddress_new/* default */.Z, {
            isCheckout: ownProps.isCheckout,
            setIsOpen: setIsOpen,
            isEdit: isEdit,
            setIsEdit: setIsEdit,
            isOpen: isOpen,
            editAddress: editAddress,
            fetchAddressList: fetchAddressList,
            deleteAddress: deleteAddress
        }))
    });
};
var mapStateToProps = function(state, ownProps) {
    return {
        loading: state.loading.loading,
        ownProps: ownProps
    };
};
var mapDispatchToProps = {
    isLoaded: loading/* isLoaded */.k
};
/* harmony default export */ var myAddress_MyAddress = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(MyAddress));


/***/ })

}]);